import { isLocalApi } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_AI_AUTOMATIONS=true in .env.local for the local API.
export const AI_AUTOMATIONS_LOCAL_API_REQUESTS = isLocalApi(
  process.env.REACT_APP_LOCAL_API_AI_AUTOMATIONS
);
